import { createSelector } from 'reselect';
import CarrierNestingOperatorPercentageColumns from '../../containers/CarrierNestingOperatorPercentageColumns';
import CarrierNestingOperatorNumberColumns from '../../containers/CarrierNestingOperatorNumberColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.CARDIT_NESTING_OPERATOR_801.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARDIT_NESTING_OPERATOR_801.isLoading;

export const getData =
  ReportDefinitions.CARDIT_NESTING_OPERATOR_801.getDataFunction();

export const getPercentageColumns =
  // eslint-disable-next-line max-len
  createSelector(getData, state => state.reporting.CARDIT_NESTING_OPERATOR_801.requestParams, CarrierNestingOperatorPercentageColumns);

export const getNumberColumns =
  // eslint-disable-next-line max-len
  createSelector(getData, state => state.reporting.CARDIT_NESTING_OPERATOR_801.requestParams, CarrierNestingOperatorNumberColumns);
